export const panelSnapshotPosts: Array<{ text: string; url: string }> = [
    {
        url:
            'https://thumb.sprinklr.com/?d=300x300&url=https%3A%2F%2Fsprcdn-assets.sprinklr.com%2F349%2Fbf32ae8d-96f2-4183-a292-b0885fae24c6-2905957331.jpg',
        text: '',
    },
    {
        url:
            'https://thumb.sprinklr.com/?d=300x300&url=https%3A%2F%2Fsprcdn-assets.sprinklr.com%2F349%2F2b76080b-dfbc-4845-850c-fa8187c1b4a1-2026382247.jpg',
        text: '',
    },
    {
        url:
            'https://thumb.sprinklr.com/?d=300x300&url=https%3A%2F%2Fsprcdn-assets.sprinklr.com%2F349%2F1d281dcc-2b02-4767-ae0f-cf4dd712fcdc-248056912.jpg',
        text: '',
    },
    {
        url:
            'https://thumb.sprinklr.com/?d=300x300&url=https%3A%2F%2Fsprcdn-assets.sprinklr.com%2F349%2Fa8bd46a1-0f34-4232-bc13-6acb1e14b29f-1159601548.jpg',
        text: '',
    },
    {
        url:
            'https://thumb.sprinklr.com/?d=300x300&url=https%3A%2F%2Fsprcdn-assets.sprinklr.com%2F349%2Fbc6941c1-4c35-4f8d-8558-132f51c6de5f-500332224.jpg',
        text: '',
    },
    {
        url:
            'https://thumb.sprinklr.com/?d=300x300&url=https%3A%2F%2Fsprcdn-assets.sprinklr.com%2F349%2F398ebe6b-4bcc-416a-a7de-175d4fb16973-778674666.jpg',
        text: '',
    },
    {
        url:
            'https://thumb.sprinklr.com/?d=300x300&url=https%3A%2F%2Fsprcdn-assets.sprinklr.com%2F349%2Faa4fbc8b-13f3-40d6-9027-e7cd0e611d92-2908003508.jpg',
        text: '',
    },
    {
        url:
            'https://thumb.sprinklr.com/?d=300x300&url=https%3A%2F%2Fsprcdn-assets.sprinklr.com%2F349%2F3f982e28-5d11-4ed0-8092-287344ba30fb-1416260447.jpg',
        text: '',
    },
    {
        url:
            'https://thumb.sprinklr.com/?d=300x300&url=https%3A%2F%2Fsprcdn-assets.sprinklr.com%2F349%2F126d4ee6-4cd3-4186-a7ba-91ce9739d61f-1830165503.jpg',
        text: '',
    },
    {
        url:
            'https://thumb.sprinklr.com/?d=300x300&url=https%3A%2F%2Fsprcdn-assets.sprinklr.com%2F349%2Fe1b4abc5-c675-4631-9f60-279a75144dca-2749469172.jpg',
        text: '',
    },
    {
        url:
            'https://thumb.sprinklr.com/?d=300x300&url=https%3A%2F%2Fsprcdn-assets.sprinklr.com%2F349%2Ffe96030f-c43f-46e9-8a78-57a65fcae127-136168368.jpg',
        text: '',
    },
];
